<template>
  <div class="row v-grid1" data-grm-comp="RoomCallMixing" ref="main" style="width: 100%; height: 100%;">
    <Loading v-if="mixerConnState == 'ready' || mixerConnState == 'connecting' || loadingGroupMode" />
    <div
      class="mixer-video"
      style="
          width: 100%;
          position: absolute;
          left: 0;
          top: 0;
          pointer-events: none;
          box-sizing: border-box;
        "
      ref="mixer_video_layer"
      v-show="secondVideo || (!isScreenShareUserMe && mixerConnState == 'connected')"
      :data-created-at="new Date()"
      :style="mixerVideoStyle"
    >
<!--  믹서 비디오-->
      <RoomVideo
        data-video-type="mixer"
        style="width: 100%; height: 100%;"
        ref="mixer_video"
        v-show="secondVideo || !isMyScreenShare"
        :muted="true"
        :data-created-at="new Date()"
        @resize="onMixerVideoResize"
      ></RoomVideo>
    </div>

    <div
      class="mixer-video-guide"
      style="width:100%; height: 100%; position: absolute; left: 0; top: 0; box-sizing: border-box;"
      ref="mixer_video_guide"
      v-show="mixerConnState == 'connected'"
    >
<!--  믹서 비디오 위에 그려지는 가이드-->
      <RoomCallMixingVideo
        v-for="ruv in roomUserVideos"
        :key="ruv.id"
        :ref="'videos_' + ruv.id"
        :video-rect="ruv"
        :mixer-video="true"
        :rectObj="rectObj"
        :videoOnly="videoOnly"
        :secondVideo="secondVideo"
      />

      <div class="sub-group-layer"
         ref="sub_group_layer"
         style="position: relative"
         v-if="isRoomMode('group')"
      >
        <RoomCallGroup
          v-for="roomGroup in roomGroups"
          :key="roomGroup.roomGroupId"
          :room-group="roomGroup"
        />
      </div>

      <div class="mixer-video-guide-info"
        :style="mixingVideoGuideInfo"
      >
        <div
          v-if="ifMixerVideoPageWrapper"
          class="mixer-video-page-wrapper"
        >
          <div class="mixer-video-page-btn prev" @click="movePage(-1)">
            {{pageInfo.curPageIndex+1}}/{{pageInfo.totalPageCount}}
          </div>
          <div class="mixer-video-page-btn next" @click="movePage(1)">
            {{pageInfo.curPageIndex+1}}/{{pageInfo.totalPageCount}}
          </div>
        </div>
      </div>
    </div>
    <GrmDraggableResizable v-if="!secondVideo
                                    && roomInfoSetting.useScreenMerger
                                    && isRoomMode('screenShare') 
                                    && (isWebinarWall || (isWebinarLive && hasSpeakerRole()))"
                           :w="previewPip.width"  :h="previewPip.height"
                           :x="previewPip.x"      :y="previewPip.y"
                           :z="previewPip.z"
                           :lock-aspect-ratio="previewPip.lockAspectRatio"
    >
      <RoomVideo class="grm-video"
                 ref="localVideo"
                 :muted="true"
                 :videoOnly="videoOnly"
      ></RoomVideo>
    </GrmDraggableResizable>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import _ from 'lodash'

import { Room } from '@/core/api/room.api'
import { GrmWebRTC } from '@/lib/gooroomee/webrtc/GrmWebRTC'

import RoomVideo from "@/components/Room/Call/RoomVideo"
import RoomCallMixingVideo from '@/components/Room/Call/mixing/RoomCallMixingVideo'
import Loading from "@/components/Common/loading/GrmLoading.vue"
import GrmDraggableResizable from "@/components/Common/draggableResizable/GrmDraggableResizable.vue";
import RoomCallGroup from "@/components/Room/Group/RoomGroupCall/RoomCallGroup.vue";

export default {
  name: 'RoomCallMixing',
  components: {
    RoomVideo,
    RoomCallMixingVideo,
    Loading,
    GrmDraggableResizable,
    RoomCallGroup
  },
  props: {
    secondVideo: {
      type: Boolean,
      default: false
    },
    videoOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      roomUserVideos: {},
      mixerConnState: 'ready',
      mixingVideoGuideInfo: {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      },
      rectObj: {},
      pageInfo: {
        curPageIndex: 0,
        totalPageCount: 1
      },
      roomGroups:{},
      mixerVideoLayerHeight: '100%',
      currentUserLayoutCount: '',
      localStream: null,
      previewPip: {
        x: 100,
        y: 100,
        z: 999,
        width: 320,
        height: 180,
        minWidth: 10,
        lockAspectRatio: false,
        previewStream: null,
      },
    }
  },
  created() {
    const mixer = this.$roomApi.Call.Mixer.getMixer();
    if(mixer?.conn?.isConnected()){
      this.mixerConnState = 'connected';
    }

    this.$roomApi.addEventListeners((this._Events = _Events()), this)

    // test
    window.$roomCallVue = this
  },

  async mounted() {
    let win = this.getDefaultView()
    // win.addEventListener('resize', e => {
    //   win.clearTimeout(this._resizeTimer)
    //   this._resizeTimer = win.setTimeout(() => {
    //     this.changeMixingLayout()
    //   }, 100)
    // })

    await this.playVideo();

    if(!this._resize_listener_){
      this._resize_listener_ = () => {
        const {offsetWidth, offsetHeight} = this.$el;
        if(this.$el._w == offsetWidth && this.$el._h == offsetHeight){
          return;
        }
        this.$el._w = offsetWidth;
        this.$el._h = offsetHeight;

        win.clearTimeout(this._resizeTimer);
        this._resizeTimer = win.setTimeout(() => {
          this.changeMixingLayout()
        }, 10)
      }
      this.getDefaultView()?.addEventListener('resize', this._resize_listener_);

      this.resizeObserver = new ResizeObserver(entries => {
        this._resize_listener_();
      });
      this.resizeObserver.observe(this.$el);
    }
  },

  destroyed() {
    this.$roomApi.removeEventListeners(this._Events);
    this.resizeObserver?.disconnect();
    this.$el?.remove();

    this.getDefaultView()?.removeEventListener('resize', this._resize_listener_);
  },

  watch: {
    'previewPip.previewStream': {
      handler(stream) {
        if (!stream) return
        this.$nextTick(async () => {
          if (!this.$refs.localVideo?.$refs?.video) return
          GrmWebRTC.attachMediaStream(this.$refs.localVideo.$refs.video, stream)
          this.$refs.localVideo.$refs.video.play().catch(e => {
              if(!e.message || e.message.includes('interrupted')){
                  return;
              }
              console.warn(e)
          })
        })
      }
    },
    secondVideo: function(secondVideo){
      this.playVideo();
    },
    userGestureInit(){
      const mixerVideo = this.$refs.mixer_video?.$refs.video;
      mixerVideo.muted = this.isMuted;
    },
    // 'me.speakerStatus': {
    //   immediate: true,
    //   handler: function(status) {
    //     if(this.isMe){
    //       return;
    //     }
    //     const video = this.$refs.mixer_video?.$refs.video;
    //     if(!video){
    //       return;
    //     }
    //     video.muted = status !== 'on';
    //   }
    // },
  },

  computed: {
    ...mapGetters('room', [
      'isRoomMode',
      'testLayoutList',
      'oneLineMixerLayoutCount',
      'roomInfoSetting',
      'isScreenShareMode',
    ]),
    ...mapGetters('call', [
      'roomCallVideoLayoutCount',
      'requestUnmute',
      'userGestureInit',
      'isWebinarWall',
      'isWebinarLive',
    ]),
    ...mapGetters('roomGroup', [
      'isInRoomGroup',
      'loadingGroupMode',
      'selectedUserIdList',
      'noContentGroupMode'
    ]),
    ...mapGetters('user', [
      'me',
      'isMe',
      'hasEmceeRole',
      'roomUserList',
			'isScreenShareUserMe',
      'roomUserList',
      'hasSpeakerRole',
    ]),

    mixerVideoHeight() {
      return Object.values(this.roomUserVideos).find(obj => {
        if (!obj.clone && !obj.empty) return obj;
      })?.height
    },
    mixerVideoGuideInfoBottomStyle() {
      return {
          height: `calc(100% - ${this.mixerVideoHeight * (this.roomCallVideoLayoutCount === `${this.oneLineMixerLayoutCount}` ? 1 : 2)}px)`,
          position: `absolute`,
          right: 0,
          bottom: 0,
          left: 0,
          pointerEvents: this.isRoomMode('quiz') || this.isRoomMode('debate') ? '' : 'none'
      }
    },
    ifMixerVideoPageWrapper() {
      return (
        this.useMixingVideoPage &&
        this.pageInfo.totalPageCount > 1 &&
        !this.isRoomMode('group') &&
        this.hasEmceeRole()
      );
    },
    mixerVideoStyle() {
      return {
        height:
        ((this.isInRoomGroup() && !this.noContentGroupMode) ||
            this.isRoomMode('debate') ||
            this.isRoomMode('quiz')
        ) ? this.mixerVideoLayerHeight : '100%',
        // zIndex: this.isScreenShareMode ? 1 : 0,
      }
    },
    isSpeakerOff(){
      return this.me.speakerStatus != 'on';
    },
    isMuted(){
      return this.isSpeakerOff;
    },
    isMyScreenShare() {
      return !!this.me?.screenStatus;
    },
    useMixingVideoPage() {
      return this.roomInfoSetting?.['useMixingVideoPage'];
    }
  },
  methods: {
    ...mapActions('room', [
      'changeMixingLayoutType'
    ]),
    ...mapActions('call', [
      'getVideoOnlyStream'
    ]),
    ...mapMutations('call',[
      'REQUEST_UNMUTE',
      'SET_USER_GESTURE_INIT',
    ]),
    ...mapActions('roomGroup', [
      'setSelectedUserIdList'
    ]),
    async playVideo(stream) {
      if(!stream){
        if(this.secondVideo){
          stream = await this.$roomApi.Call.Mixer.getSecondStream();
          if(!stream
              || stream.getVideoTracks().length === 0
              || stream.getVideoTracks()[0].muted
          ){
            console.log('# chk second stream : muted[%s]',
                stream?.getVideoTracks()[0]?.muted,
                stream?.getVideoTracks()[0]
            );
            stream = this.$roomApi.Call.Mixer.getStream();
          }
        }else{
          stream = this.$roomApi.Call.Mixer.getStream();
        }
        if(!stream){
          return;
        }
      }

      const mixerVideo = this.$refs.mixer_video?.$refs.video;
      if(!mixerVideo){
        console.warn('mixerVideo is null');
        return;
      }

      stream = await this.getVideoOnlyStream({stream});
      if(mixerVideo.srcObject === stream){
        return;
      }

      function checkError(e){
        if(e.message.includes('aborted')){
          // 자동 재생 문제
          if(!mixerVideo.muted){
            console.error(this.$t('call.error.autoplay'));
            return;
          }
        }else if(e.message.includes('interrupted by a call to pause')){
          // ignore
        }else{
          console.error(e);
        }
      }

      // if(mixerVideo.muted){
      //   mixerVideo.addEventListener('play', e => {
      //     try{
      //       mixerVideo.muted = false;
      //     }catch(e){
      //       checkError(e);
      //     }
      //   }, {once: true});
      // }

      const THIS = this;
      GrmWebRTC.attachMediaStream(mixerVideo, stream);
      mixerVideo.play().catch(e => {
        if(e.message.includes('didn\'t interact')){ // 자동 재생 문제
          mixerVideo.muted = true;
          this.REQUEST_UNMUTE({
            callback: () => {
              this.$alert({
                text: this.$t('call.mixing.confirmAudio'),
                onlyOk: true,
                ok(){
                  THIS.SET_USER_GESTURE_INIT();
                },
              })
            }
          });
        }
      });
    },
    onMixerVideoResize() {
      let video = this.$refs.mixer_video?.$refs.video
      if (!video) return
      // if(video.videoWidth <= 0 || video.videoHeight <= 0){
      //   return;
      // }
      console.log(
          '@ mixer video play : %d x %d',
          video.videoWidth,
          video.videoHeight
      )
      this.changeMixingLayout()
    },

    resizeMixingLayout() {
      const mainRect = this.$refs.main.getBoundingClientRect();
      // let video = this.$refs.mixer_video.$refs.video;

      ['width', 'height'].forEach(t => {
        if (mainRect[t] % 2 !== 0) {
          mainRect[t] = Math.ceil(mainRect[t])
        }
      })

      let layerHeight = mainRect.height

      // mixer_video_layer resize
      Object.assign(this.$refs.mixer_video_layer.style, {
        width: mainRect.width + 'px',
        height: layerHeight + 'px'
      })
      this.$refs.mixingGuideLayer &&
      Object.assign(this.$refs.mixingGuideLayer.style, {
        width: mainRect.width + 'px',
        height: layerHeight + 'px'
      })

      return mainRect
    },

    getUserVideo(user) {
      let userId = user
      if (typeof userId === 'object') {
        userId = user.userId
      }

      let videos = this.$refs['videos_' + userId]
      if (!videos || videos.length === 0) return null

      if (videos.length > 1) {
        console.warn('multiple videos :', userId, videos.length)
      }
      return videos[0]
    },

    changeMixingLayout(data) {
      let $main = this.$refs.main

      let $mixingVideo = this.$refs.mixer_video?.$refs.video
      if(!$mixingVideo){
        console.warn('# mixing video is null');
        return;
      }
          // if($mixingVideo.videoWidth <= 0){
          //   console.warn('#mixer video width 0');
          //   return;
          // }

      // // resize
      // let width, height;
      // (() => {
      //   Object.assign($main.style, {
      //     width: '100%', height: '100%'
      //     // width: $mixingVideo.videoWidth+'px', height: $mixingVideo.videoHeight+'px'
      //   });
      //   width = $main.clientWidth, height = $main.clientHeight;
      //
      //   if($mixingVideo.videoHeight < $mixingVideo.videoWidth){
      //     let ratio = $main.clientWidth / $mixingVideo.videoWidth;
      //     Object.assign($main.style, {
      //       width: $mixingVideo.videoWidth + 'px',
      //       height: $mixingVideo.videoHeight + 'px',
      //       transform: `scale(${ratio})`
      //     })
      //   }
      //
      //   // let style = {
      //   //   width: width+'px', //$main.clientWidth + 'px',
      //   //   height: height+'px' //$main.clientHeight + 'px',
      //   // };
      //   // Object.assign($main.style, style);
      //   //Object.assign(this.$refs.mixer_video_layer.style, style);
      //   // Object.assign(this.$refs.mixer_video_guide.style, style);
      // })();

      let options = {
        videoWidth: $mixingVideo.videoWidth || 1280, // test
        videoHeight: $mixingVideo.videoHeight || 720, // test
        // videoWidth: width || 1280, // test
        // videoHeight: height || 720, // test
        viewWidth: $main.clientWidth,
        viewHeight: $main.clientHeight
        // useSecondStream: DATA.useSecondStream // second stream 재생 여부
      }

      if (this.quizStatus) {
        Object.assign(options,  { layoutMarginTop : 0 })
      }

      if(this.secondVideo){
        Object.assign(options,  { useSecondStream: true })
      }

      let rectObj = data || Room.Call.Mixer.getMixingLayoutRect(options)
      if (!rectObj) {
        return
      }

      this.rectObj = rectObj;
      this.mixerVideoLayerHeight = this.getMixerVideoLayerHeight(options)

      let setUserVideos = (rectList, roomUserVideos, removeTargets) => {
        if(!rectList) return;
        rectList.forEach(async (rect) => {
          rect.emptyUser = !rect.userId
          if (rect.emptyUser) {
            rect.userId = '_empty_' + rect.idx
          }
          let id = rect.id = rect.id || '' + rect.userId

          let $video = roomUserVideos[id]

          // border 값
          // rect.width -= 1;
          // rect.height -= 1;

          // video vue existed already. video  가 있으므로 rect 정보만 갱신
          if ($video) {
            _.merge($video, rect)
          } else {
            this.$set(roomUserVideos, id, rect)
          }
          // 삭제대상에서 제외
          removeTargets.delete(id)
        })
      }

      // let removeUserTargets = new Set(Object.keys(this.roomUserVideos))
      let removeGroupTargets = new Set(Object.keys(this.roomGroups))
      if(!data) {
        let base = rectObj.base;
        if(base) {
          let removeUserTargets = new Set(Object.keys(this.roomUserVideos))
          setUserVideos(base, this.roomUserVideos, removeUserTargets) // base loop end

          // 위에 해당되지 않는 video 들을 제거한다.
          removeUserTargets.forEach(id => {
            this.removeObjectInData(this.roomUserVideos, id)
          })

          Object.assign(this.mixingVideoGuideInfo, {
            left: base.left + 'px', top: base.top + 'px', width: base.width + 'px', height: base.height + 'px'
          });
          Object.assign(this.pageInfo, base.pageInfo);
        }
      } else {
        let THIS = this
        // group videoLayout
        rectObj.rectList && rectObj.rectList.forEach(async (rect) => {
          let id = rect.id || rect.roomGroupId
          if(id) {
            let roomGroup = THIS.roomGroups[id]
            if (!roomGroup) {
              Object.assign(rect, rect.roomUserVideos = {})
              THIS.$set(THIS.roomGroups, id, rect)
            } else {
              _.merge(roomGroup, rect)
            }

            let roomUserVideos = THIS.roomGroups[id]['roomUserVideos']
            let removeGroupUserTargets = new Set(Object.keys(roomUserVideos))

            setUserVideos(rect.videoRectList, roomUserVideos, removeGroupUserTargets)
            if(roomUserVideos) {
              for (const [key, value] of Object.entries(roomUserVideos)) {
                value['roomGroupId'] = id;
              }
            }
            let maxVideoHeight = Math.max.apply(Math, rect.videoRectList.map((ru) => ru.height))
            Object.assign(THIS.roomGroups[id], {
              videoHeight: maxVideoHeight,
              contentHeight : THIS.roomGroups[id].height - maxVideoHeight
            })
            removeGroupUserTargets.forEach(id => {
              this.removeObjectInData(roomUserVideos, id)
            })
          }
          removeGroupTargets.delete(id)
        })
      }
      // 위에 해당되지 않는 video 들을 제거한다.
      // removeUserTargets.forEach(id => {
      //   this.removeObjectInData(this.roomUserVideos, id)
      // })

      // 위에 해당되지 않는 group 들을 제거한다.
      removeGroupTargets.forEach(id => {
        this.removeObjectInData(this.roomGroups, id)
      })
      let group = rectObj.group;
      if(Room.isRoomGroupMode() && group) {
        let myGroup = group.myGroup
        if(myGroup) {
          group.rectList.push(Object.assign(myGroup.base, {
            roomGroupId: myGroup.roomGroupId,
            videoRectList: myGroup.base.map(r => r)
          }))

          myGroup.base.height = $main.offsetHeight
          group.height = $main.offsetHeight
        }


        Object.assign(this.$refs.sub_group_layer.style, {
          left: group.left + 'px',
          top: (myGroup && !this.noContentGroupMode ? 0 : group.top) + 'px',
          height: group.height + 'px',
          width: group.width + 'px',
        })

        this.changeMixingLayout(Object.assign(group, {targets: this.roomGroups}))
      }
    },

    removeObjectInData(data, id) {
      if(!data) return;
      data[id] = null
      delete data[id]
    },
    movePage(n) {
      if (!this.hasEmceeRole()) return;

      clearTimeout(this._mp_timer);

      let page = this.pageInfo.curPageIndex + n;
      if(page < 0){
        page = this.pageInfo.totalPageCount - 1;
      }else if(page > this.pageInfo.totalPageCount - 1){
        page = 0;
      }

      this.pageInfo.curPageIndex = page;

      this._mp_timer = setTimeout(() => {
        this.$roomApi.Call.Mixer.changeMixingPage({page});
      }, 100)
    },
    createRoomGroupVideo(group) {
      if(!group) {
        return;
      }
    },
    getMixerVideoLayerHeight({videoHeight, videoWidth, viewWidth, viewHeight}) {
      let ratio = viewWidth / videoWidth;
      if(videoHeight * ratio > viewHeight){
        return '100%';
      }else{
        return (viewWidth * (videoHeight/videoWidth)) + 'px';
      }
    },
  }
}

function _Events(){
  return {
    room_call_startMixerConnection: function(e) {
      this.mixerConnState = 'connecting'
    },
    room_call_mixerConnected: function(e) {
      this.mixerConnState = 'connected'
    },
    room_call_mixerConnectFailed: function(e) {
      this.mixerConnState = 'fail'
    },
    room_call_addstream_mixer_primary: async function(e) {
      await this.playVideo();
    },
    room_call_addstream_mixer_second: function(e) {

    },
    room_call_changeMixingLayout: function(e) {
      // this.changeMixingLayout(null, e.data)
      this.changeMixingLayout()
    },
    room_call_loadLocalStream: function(e) {
      const {data: {stream}} = e;
      if(this.previewPip.previewStream !== stream)
        this.previewPip.previewStream = stream;
    },
    room_group_changeRoomGroup: function(e) {
      this.changeMixingLayout();
    }
  }
}
</script>

<style lang="scss" scoped>
.mixer-video-guide {
  overflow: hidden;
}
.mixer-video-guide-info {
  position: absolute;
  pointer-events: none;
  z-index: 4;
}
.mixer-video-page-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  pointer-events: none;
  z-index: 2;

  .mixer-video-page-btn {
    width: fit-content;
    min-width: 40px;
    box-sizing: border-box;
    position: absolute;
    opacity: 0.8;
    pointer-events: auto;
    color: #fff;
    padding: 4px 6px;
    background-color: black;
    font-size: 12px;
    font-weight: bold;
    line-height: 1;
    user-select: none;

    &:hover {
      background-color: #00b4b4 !important;
      opacity: 1;
    }

    &.prev {
      left: 0;
      padding-left: 14px;
      background: black url('~@/assets/roomType/lms/img/icon/ico_arrowLineThickLeft_white.svg') no-repeat left 4px center / auto 40%;
    }
    &.next {
      right: 0;
      padding-right: 14px;
      background: black url('~@/assets/roomType/lms/img/icon/ico_arrowLineThickRight_white.svg') no-repeat right 4px center / auto 40%;
    }
  }
}
</style>